// Module
var code = "<div class=\"intro__wrapper\"> <div class=\"intro__items p1 bold\" data-scroll data-scroll-id=\"intro\" data-scroll-sticky data-scroll-target=\".intro__wrapper\"> Get lost in <p> the fog Get fog in the dot Get dog on the fox Get a blog by the dog Get roast on a yatch Get most of the toast </p> </div> </div> ";
// Exports
export default code;